exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.show-more-ticket-right-field {\n  cursor: pointer;\n  padding: 5px;\n  background:#FCFCFC;\n  text-align:center;\n}\n.RightMerchantOrder, .RightMerchant, .RightEndAt, .RightCustomerSchedule, .RightCallInfo, .RightWorkflow, .RightShop {\n  display: none;\n}\n.popper_class_0 {\n  margin-left: -150px;\n}\n.popper_class_0 .popper__arrow {\n  left : 300px!important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-003d7968","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/TicketDetailRight.vue
// module id = 735
// module chunks = 75